import fadeTabs from '../../../components/tabs.js';
import { fadeOut, fadeIn } from '../../../utility';

export default class LabGroupTabs {
  constructor(el) {
    this.el = el;
    this.tabList = this.el.querySelector('[data-fade-tablist]');
    this.initSelect = 0;

    if (window.location.hash) {
      const hashId = window.location.hash.replace('#', '');
      const initialTab = this.el.querySelector(`[data-tab-slug="${hashId}"]`);
      this.initSelect = parseInt(initialTab.getAttribute('data-fade-tabs-id'));
      this.tabList.scroll(initialTab.offsetLeft, 0);
    }

    this.init();
  }

  init() {
    return new fadeTabs(this.el, {
      childSelector: '[data-fade-tabs-id]',
      activeClass: 'content-tabs__tab--active',
      initSelect: this.initSelect,
      onSelect: (activeTab, inactiveTabs) => {
        inactiveTabs.forEach(tab => {
          fadeOut(document.querySelector(`[data-fade-tabs-content="${tab.getAttribute('data-fade-tabs-id')}"]`), {
            done() {
              fadeIn(document.querySelector(`[data-fade-tabs-content="${activeTab.getAttribute('data-fade-tabs-id')}"]`));
              setHash(activeTab.getAttribute('data-tab-slug'));
            },
          });
        });
      },
    });
  }
}

function setHash(tabContentId) {
  if (window.location.hash !== tabContentId) {
    window.location.hash = tabContentId;
  }
}
